import React from 'react';
import AnalyticsTab from '../components/dashboard/AnalyticsTab';
import DataQualityTab from '../components/dashboard/DataQualityTab';

function SectionHeader({ title, subtitle }) {
  return (
    <div className="mb-5">
      <h2 className="text-xl font-bold text-slate-900 mb-0.5">{title}</h2>
      <p className="text-slate-500 text-sm">{subtitle}</p>
    </div>
  );
}

export default function AnalyticsPage() {
  return (
    <div className="p-3 sm:p-6">
      <div className="mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-1">Analytics & Insights</h1>
        <p className="text-slate-500 text-sm">Membership health, age coverage and contribution trends</p>
      </div>

      <div className="space-y-10">
        {/* 1 — Membership Intelligence */}
        <section>
          <SectionHeader
            title="Membership Intelligence"
            subtitle="Profile completeness, age coverage and field gaps — identify who needs updating before it matters"
          />
          <DataQualityTab />
        </section>

        <div className="border-t border-slate-200" />

        {/* 2 — Payment Trends */}
        <section>
          <AnalyticsTab title="Payment Trends" />
        </section>
      </div>
    </div>
  );
}
